// extracted by mini-css-extract-plugin
export default {"MailTo":"MailTo_MailTo__rbOgz","Link":"MailTo_Link__J5BCK"};